/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetStampAssetsRequest} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_stamp_assets.pb'
import {StampsConfig} from '@cash-web/protos/squareup/franklin/common/stamp.pb'


export const getStampAssets = (request: GetStampAssetsRequest, options?: CashRequestOptions) => post<GetStampAssetsRequest, StampsConfig>("/2.0/cash/get-stamp-assets", request, {...options, rejectOnError: true })